import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiInterface, ApiQueryParamsDTO } from '../api-interface';
import { ApiService } from '../api.service';
import { NfeEventoEnvioDTO, NfeImpressaoDTO, NfeRespostaEventoEnvioDTO } from '../../models/nfe.model';

@Injectable({
    providedIn: 'root',
})
export class NfeService implements ApiInterface {
    constructor(private apiService: ApiService) { }

    get<T>(
        url: string,
        data?: ApiQueryParamsDTO
    ): Observable<NfeRespostaEventoEnvioDTO> {
        const queryParams = this.apiService.buildQueryParams(data);
        const patch = queryParams ? `${url}?${queryParams}` : url;
        return this.apiService.read<NfeRespostaEventoEnvioDTO>(patch);
    }

    getById<T>(url: string, id: string): Observable<any> {
        return this.apiService.read<NfeEventoEnvioDTO>(`${url}/${id}`);
    }

    post<T>(url: string, data?: NfeEventoEnvioDTO): Observable<NfeEventoEnvioDTO> {
        return this.apiService.create<NfeEventoEnvioDTO>(url, data);
    }

    patch<T>(url: string, data?: NfeEventoEnvioDTO): Observable<NfeEventoEnvioDTO> {
        return this.apiService.patch<NfeEventoEnvioDTO>(url, data);
    }

    put<T>(url: string, data?: NfeEventoEnvioDTO): Observable<NfeEventoEnvioDTO> {
        return this.apiService.update<NfeEventoEnvioDTO>(url, data);
    }

    delete<T>(url: string): Observable<any> {
        return this.apiService.delete(url);
    }

    imprimirNfe(notaId: number, tipoImpressao: string = 'A4'): Observable<NfeImpressaoDTO> {
        return this.apiService.read<NfeImpressaoDTO>(`/nfe/imprimir/${notaId}?tipoImpressao=${tipoImpressao}`);
    }
}
